import React, { useEffect, useState, FunctionComponent } from "react";
import {BarChart,Bar,Cell,XAxis,YAxis,CartesianGrid,Tooltip, LineChart, Line,} from "recharts";
import { PieChart, Pie, Sector, ResponsiveContainer } from "recharts";
import styles from "./style.module.scss";
import "./style.scss";
import LoaderSpinner from "../../UI/LoaderSpinner/LoaderSpinner";
import axios from "axios";
import { DailyIndexModelResponse, LoadProfileChartModelResponse } from "types";
import { useParams } from "react-router-dom";
import { DatePicker } from "antd";
import locale from "antd/es/date-picker/locale/tr_TR";
import SearchIcon from "assets/icons/fi-rr-search.svg";
import type { DatePickerProps } from "antd";
import { locationController } from "utils/locationhelper";
import moment from "moment";
import AuthService from "../../../services/AuthService";
import { useKeycloak } from "@react-keycloak/web";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify'

interface TooltipProps {
  active: boolean;
  payload: any;
  label: string;
}

const customFormat: DatePickerProps["format"] = (value) =>
    `${value.date()} ${value.localeData().months(value)} ${value.year()} `;

const TesisatDetaylariDurumGrafikleri = () => {
  const params = useParams<any>();
  const [isLoading, setIsLoading] = useState(false);
  const [dailyIndexList, setDailyIndexList] = useState<DailyIndexModelResponse | []>(null!); 
  const [monthValue, setMonthValue] = useState(new Date().getMonth() + 1);
  const [yearValue, setYearValue] = useState(new Date().getFullYear());
  const [dayValue, setDayValue] = useState(new Date().getDate());
  const [totalT, setTotalT] = useState(0);
  const [kw, setKw] = useState(0);
  const [indicatorAngle, setIndicatorAngle] = useState(-1);
  const [pieChartData, setPieChartData] = useState([
    { name: "T1", value: 400, listValue: "T1" },
    { name: "T2", value: 200, listValue: "T2" },
    { name: "T3", value: 400, listValue: "T3" },
  ]);
  const [currentValueData, setCurrentValueData] = useState([
    { name: "1. Faz", value: 0 },
    { name: "2. Faz", value: 0 },
    { name: "3. Faz", value: 0 },
  ]);
  const [percentData, setPercentData] = useState<number[]>([]);
  const COLORS = ["#f1be5b", "#5564d7", "#64d26f"];
  const COLORS2 = ["#64d26f", "#f1be5b", "#dc2525"];

  const [showT0Cekis, setShowT0Cekis] = useState(true);
  const [showRiCekis, setShowRiCekis] = useState(true);
  const [showRcCekis, setShowRcCekis] = useState(false);
  const [showT0Veris, setShowT0Veris] = useState(true);
  const [showRiVeris, setShowRiVeris] = useState(false);
  const [showRcVeris, setShowRcVeris] = useState(false);

  const [dateRange, setDateRange] = useState<any[]>([]);

  const dateFormatTr = "DD.MM.YYYY";
  const dateFormat = "YYYY-MM-DD";

  const [chartData, setChartData] = useState<LoadProfileChartModelResponse | []>(null!);
  const [showDetail, setShowDetail] = useState(false);
  const [windowWidth, setWindowWidth] = useState(0);

  const RangePickerChart = DatePicker.RangePicker;

  const { keycloak } = useKeycloak();
  const auth = new AuthService(keycloak);

  let companyId = locationController();

  const getDailyIndex = async() => {
    setIsLoading(true);

    auth.axios(`/DailyIndex/GetDailyIndexForStatusCharts`, null, {
      tesisatNo: params.id,
      companyId : companyId,
      pageSize: 100,
      page: 1,
      day: dayValue,
      month: monthValue,
      year: yearValue 
    })
    .then(response => {
      setIsLoading(false);
      if (response.data.success === true) {
        setDailyIndexList(response.data.data.itemList)
        setKw(Math.max(...response.data.data.itemList.map((item: { demand: any; }) => item.demand)));
        setTotalT(parseFloat(response.data.data.itemList[0].toplamAktif));
        setPieChartData([
          { name: "T1", value:parseFloat(response.data.data.itemList[0].t1Gunduz) , listValue: "T1" },
          { name: "T2", value:parseFloat(response.data.data.itemList[0].t2Puant), listValue: "T2" },
          { name: "T3", value:parseFloat(response.data.data.itemList[0].t3Gece), listValue: "T3" },
        ]);
        setCurrentValueData([
          { name: "1. Faz", value:parseFloat(response.data.data.itemList[0].l1) },
          { name: "2. Faz", value:parseFloat(response.data.data.itemList[0].l2) },
          { name: "3. Faz", value:parseFloat(response.data.data.itemList[0].l3) },
        ]);
      }
      else {
        if (response.data.message) {
          toast.error(response.data.message, {
            position: toast.POSITION.TOP_RIGHT,
            theme: "colored",
          });
        }
      }

    }).catch(err => {
      setIsLoading(false);
      
      toast.error(err.response.data.message, {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
      });

    });
    
  }

  const getChartData = async () => {
    var range = dateRange as string[][];

    var startDay = moment(range[0], dateFormatTr);
    var endDay = moment(range[1], dateFormatTr);

    var meterDate = startDay + "," + endDay;

    auth.axios(`/HourlyConsumption/GetProfileDataByRange`, null, {
      tesisatNo: params.id,
      email: keycloak?.tokenParsed?.email,
      companyId : companyId,
      startYear: Number(startDay.format('YYYY')),
      startMonth: Number(startDay.format('MM')),
      startDay: Number(startDay.format('DD')),
      endYear: Number(endDay.format('YYYY')),
      endMonth:  Number(endDay.format('MM')),
      endDay: Number(endDay.format('DD')),
    })

    // setIsLoading(true);
      .then((response) => {
        // setIsLoading(false);
        if (response.data.success === true) {
          setChartData(response.data.data.itemList);
        } else {
        }
      })
      .catch((err) => {
        // setIsLoading(false);
        
        toast.error(err.response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
        });
      });
  };

  useEffect(() => {
    window.addEventListener("resize", () => setWindowWidth(window.innerWidth));
  });

  useEffect(() => {
    setWindowWidth(window.innerWidth);
  }, [window.innerWidth]);

  useEffect(() => {
    if(yearValue!==0 && monthValue!==0 && dayValue!==0)
      getDailyIndex()

      if(dateRange.length> 0){
        getChartData(); 
      }

  }, []);

  useEffect(() => {
    let _total = 0;
    let _array: any[] = [];
    let _valueArray: string[] = [];
    pieChartData.map((item) => {
      _total += item.value;
      _valueArray.push(item.listValue);
    });
    pieChartData.map((item) => {
      _array.push({
        name: item.listValue,
        value: Math.round((Number(item.value) / Number(_total)) * 100),
      });
    });
    setPercentData(_array);
  }, [pieChartData]);

  useEffect(() => {
    let _calculate = Math.round(kw);
    setIndicatorAngle(135 + (_calculate * 28) / 25);
  }, [kw]);

  const maxPower = [
    { name: "Group A", value: 400 },
    { name: "Group B", value: 200 },
    { name: "Group C", value: 400 },
  ];

  const colors = ["#f1be5b", "#5564d7", "#64d26f"];

  const CustomTooltip = ({ active, payload, label }: TooltipProps) => {
    if (active && payload && payload.length) {
      return (
        <div
          onMouseEnter={() => {
            console.log(payload);
          }}
          className="custom-tooltip"
        >
          <p
            onClick={() => {
              console.log(payload);
            }}
            className="label"
          >{`${payload[0].payload.name} : ${payload[0].value}`}</p>
        </div>
      );
    }

    return null;
  };

  return (
    <div>
      <ToastContainer/>
      <div className={styles.durumGrafikleri}>
        <div className={styles.headerCard}>
          <div className={styles.card}>
            <div>Tarih</div>
            <div className={styles.rangePicker}>
            <DatePicker
                placeholder={"Tarih Seçiniz"}
                suffixIcon={false}
                locale={locale}
                bordered={false}
                format={customFormat}
                picker="date"
                defaultValue={moment()}
                disabledDate={(current) => {
                  return current && current.valueOf() >= Date.now();
                }} 
                onChange={(date:any) => {
                  setMonthValue(date?.month()+1)
                  setYearValue(date?.year())
                  setDayValue(date?.date())
                }}
              />
            </div>
            <img
              onClick={() => {
                getDailyIndex();
              }}
              src={SearchIcon}
              alt=""
            />
          </div>
        </div>
        <div className={styles.grafikCardbody}>
          <div className={styles.left}>
            <div className={styles.centerText}>
              <div>T0</div>
              <div>{totalT}</div>
            </div>
            <div className={styles.rightInfo}>
              {percentData.map((item: any, index: number) => (
                <div key={index}>
                  <div className={styles.first}>
                    <div
                      style={{
                        backgroundColor: `${COLORS[index % COLORS.length]}`,
                      }}
                      className={styles.dot}
                    ></div>
                    <div className={styles.info}>
                      <div>%{item.value}</div>
                      <div>{item.name}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className={styles.header}>Son Endeks - Aktif Enerji</div>
            <div className={styles.body}>
              {/* <div className={styles.item}>
                <div>Sayaç Zamanı</div>
                <div>10/02/2022, 14:16</div>
              </div> */}
              <div className={styles.item}>
                <div>T0</div>
                <div>{totalT} KWH</div>
              </div>
              <div id="container" className={styles.container}>
                <div className={styles.chartContainer}>
                  <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                      <Pie
                        style={{ transform: "scale(1.275)" }}
                        data={pieChartData}
                        startAngle={240}
                        cx={100}
                        cy={100}
                        endAngle={-60}
                        innerRadius={70}
                        outerRadius={80}
                        fill="#8884d8"
                        radius={10}
                        paddingAngle={5}
                        isAnimationActive={true}
                        dataKey="value"
                        cornerRadius={20}
                      >
                        {pieChartData.map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={COLORS[index % COLORS.length]}
                            radius={10}
                            onClick={() => {
                              // console.log(entry);
                              // setLastEndexValue(entry.value);
                              // setLastEndexTitle(entry.name);
                            }}
                          />
                        ))}
                      </Pie>
                      <Tooltip
                        content={
                          <CustomTooltip
                            active={true}
                            label="test"
                            payload={pieChartData}
                          />
                        }
                      />
                    </PieChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.center}>
            {/* <div className={styles.rightInfo}>
              <div className={styles.first}>
                <div className={styles.dot}></div>
                <div className={styles.info}>
                  <div>1. Faz</div>
                </div>
              </div>
              <div className={styles.second}>
                <div className={styles.dot}></div>
                <div className={styles.info}>
                  <div>2. Faz</div>
                </div>
              </div>
              <div className={styles.third}>
                <div className={styles.dot}></div>
                <div className={styles.info}>
                  <div>3. Faz</div>
                </div>
              </div>
            </div> */}
            <div className={styles.header}>Akım Değeri</div>
            <div className={styles.body}>
              {/* <div className={styles.item}>
                <div>Sayaç Zamanı</div>
                <div>10/02/2022, 14:16</div>
              </div> */}

              <div className={styles.chart}>
                <div className={styles.barChart}>
                  <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                      width={300}
                      height={200}
                      data={currentValueData}
                      margin={{
                        top: 20,
                        right: 30,
                        left: 20,
                        bottom: 5,
                      }}
                    >
                      <XAxis dataKey="name" />
                      <YAxis />
                      <Tooltip />
                      <Bar
                        dataKey="value"
                        fill="#486072"
                        barSize={20}
                        radius={[10, 10, 0, 0]}
                        isAnimationActive={true}
                        style={{ backgroundColor: "#f8f8f8" }}
                      >
                        {currentValueData.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={colors[index % 20]} />
                        ))}
                      </Bar>
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.right}>
            <div className={styles.rightInfo}>
              <div className={styles.third}>
                <div className={styles.dot}></div>
                <div className={styles.info}>
                  <div>Minimum Değer: 0</div>
                </div>
              </div>
              <div className={styles.second}>
                <div className={styles.dot}></div>
                <div className={styles.info}>
                  <div>Maksimum Değer: 250</div>
                </div>
              </div>
            </div>
            <div className={styles.header}>En Yüksek Aktif Güç</div>
            <div className={styles.body}>
              {/* <div className={styles.item}>
                <div>Sayaç Zamanı</div>
                <div>10/02/2022, 14:16</div>
              </div> */}
              <div className={styles.item}>
                <div>Maksimum Güç</div>
                <div>{kw} KWH</div>
              </div>
              <div className={styles.container}>
                <div className={styles.centerText}>
                  <div className={styles.kW}>KW</div>
                  <div
                    style={{
                      transform: `rotate(${indicatorAngle}deg)`,
                    }}
                    className={styles.indicator}
                  >
                    <div className={styles.redDot}></div>
                  </div>
                  <div className={styles.number}>{kw}</div>
                </div>

                <div className={styles.chartContainer}>
                  <ResponsiveContainer width="100%" height="100%">
                    <PieChart className={styles.pie}>
                      <Pie
                        style={{ transform: "scale(1.275)" }}
                        data={maxPower}
                        startAngle={240}
                        cx={100}
                        cy={100}
                        endAngle={-60}
                        innerRadius={70}
                        outerRadius={80}
                        fill="#8884d8"
                        paddingAngle={5}
                        isAnimationActive={true}
                        dataKey="value"
                        cornerRadius={20}
                      >
                        {maxPower.map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={COLORS2[index % COLORS2.length]}
                            radius={10}
                          />
                        ))}
                      </Pie>
                    </PieChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className={styles.gunBazindaEndex}>
            <div className={styles.headerCard}>
              <div className={styles.cardSearch}>
                <div>Zaman Aralığı</div>
                <div className={styles.rangePicker}>
                  <RangePickerChart
                    placeholder={[
                      "Verilerini Görmek İstediğiniz Tarih Aralığını Seçiniz",
                      "",
                    ]}
                    suffixIcon={false}
                    separator=""
                    locale={locale}
                    bordered={false}
                    format={dateFormatTr}
                    onChange={(start: any, end: any) => {

                      const momentList = [];
                      momentList.push(end[0]);
                      momentList.push(end[1]);
                  
                      setDateRange(momentList);
                    }}
                  />
                  </div>
                  <img
                    onClick={() => {
                      getChartData();
                    }}
                    src={SearchIcon}
                    alt=""
                  />
                </div>
              
            </div>

      
            <div className={styles.card}>
              <div className={styles.list}>
                <div className={styles.secret}></div>
                <div
                  style={{ opacity: `${showT0Cekis ? "1" : "0.2"}` }}
                  className={styles.listItem}
                >
                  <div
                    style={{ backgroundColor: "#ae5a0d" }}
                    className={styles.listItemCircle}
                  ></div>
                  <div
                    onClick={() => {
                      setShowT0Cekis(!showT0Cekis);
                    }}
                    className={styles.listItemText}
                  >
                    +T0 (Çekiş)
                  </div>
                </div>
                <div
                  style={{ opacity: `${showRiCekis ? "1" : "0.2"}` }}
                  className={styles.listItem}
                >
                  <div
                    style={{ backgroundColor: "#ff7a00" }}
                    className={styles.listItemCircle}
                  ></div>
                  <div
                    onClick={() => {
                      setShowRiCekis(!showRiCekis);
                    }}
                    className={styles.listItemText}
                  >
                    +Ri (Çekiş)
                  </div>
                </div>
                <div
                  style={{ opacity: `${showRcCekis ? "1" : "0.2"}` }}
                  className={styles.listItem}
                >
                  <div
                    style={{ backgroundColor: "#8f00ff" }}
                    className={styles.listItemCircle}
                  ></div>
                  <div
                    onClick={() => {
                      setShowRcCekis(!showRcCekis);
                    }}
                    className={styles.listItemText}
                  >
                    +Rc (Çekiş)
                  </div>
                </div>
                <div
                  style={{ opacity: `${showT0Veris ? "1" : "0.2"}` }}
                  className={styles.listItem}
                >
                  <div
                    style={{ backgroundColor: "#d80684" }}
                    className={styles.listItemCircle}
                  ></div>
                  <div
                    onClick={() => {
                      setShowT0Veris(!showT0Veris);
                    }}
                    className={styles.listItemText}
                  >
                    +T0 (Veriş)
                  </div>
                </div>
                <div
                  style={{ opacity: `${showRiVeris ? "1" : "0.2"}` }}
                  className={styles.listItem}
                >
                  <div
                    style={{ backgroundColor: "#08cbd8" }}
                    className={styles.listItemCircle}
                  ></div>
                  <div
                    onClick={() => {
                      setShowRiVeris(!showRiVeris);
                    }}
                    className={styles.listItemText}
                  >
                    +Ri (Veriş)
                  </div>
                </div>
                <div
                  style={{ opacity: `${showRcVeris ? "1" : "0.2"}` }}
                  className={styles.listItem}
                >
                  <div
                    style={{ backgroundColor: "#b3a28a" }}
                    className={styles.listItemCircle}
                  ></div>
                  <div
                    onClick={() => {
                      setShowRcVeris(!showRcVeris);
                    }}
                    className={styles.listItemText}
                  >
                    +Rc (Veriş)
                  </div>
                </div>
              </div>
              <div className={styles.lineChart}>
                <div className={styles.leftText}>
                  <div>Tüketim</div>
                  <div>-</div>
                  <div>Üretim</div>
                </div>
                <ResponsiveContainer>
                  <LineChart
                    width={1000}
                    height={300}
                    data={chartData}
                    margin={{
                      top: 45,
                      right: windowWidth > 768 ? 100 : 10,
                      left: -15,
                      bottom: windowWidth > 768 ? 10 : 50,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis xAxisId={0} dataKey="day" dy={10} />
                    <XAxis
                      axisLine={false}
                      xAxisId={1}
                      dataKey="time"
                      tickSize={0}
                      dy={5}
                    />
                    <YAxis />
                    <Tooltip />
                    {showT0Cekis && (
                      <Line
                        type="monotone"
                        dataKey="t0Cekis"
                        stroke="#ae5a0d"
                        strokeWidth={2}
                        dot={false}
                        activeDot={{
                          stroke: "#ff7a00",
                          strokeWidth: 2,
                          fill: "#ff7a00",
                        }}
                        style={{ display: `${showT0Cekis ? "block" : "none"}` }}
                      />
                    )}
                    {showRiCekis && (
                      <Line
                        type="monotone"
                        dataKey="riCekis"
                        stroke="#ff7a00"
                        strokeWidth={2}
                        dot={false}
                        activeDot={{
                          stroke: "#ff7a00",
                          strokeWidth: 2,
                          fill: "#ff7a00",
                        }}
                      />
                    )}
                    {showT0Veris && (
                      <Line
                        type="linear"
                        dataKey="t0Veris"
                        stroke="#d80684"
                        strokeWidth={2}
                        dot={false}
                        activeDot={{
                          stroke: "#d80684",
                          strokeWidth: 2,
                          fill: "#d80684",
                        }}
                      />
                    )}
                    {showRcCekis && (
                      <Line
                        type="linear"
                        dataKey="rcCekis"
                        stroke="#8f00ff"
                        strokeWidth={2}
                        dot={false}
                        activeDot={{
                          stroke: "#8f00ff",
                          strokeWidth: 2,
                          fill: "#8f00ff",
                        }}
                      />
                    )}
                    {showRiVeris && (
                      <Line
                        type="linear"
                        dataKey="riVeris"
                        stroke="#08cbd8"
                        strokeWidth={2}
                        dot={false}
                        activeDot={{
                          stroke: "#08cbd8",
                          strokeWidth: 2,
                          fill: "#08cbd8",
                        }}
                      />
                    )}
                    {showRcVeris && (
                      <Line
                        type="linear"
                        dataKey="rcVeris"
                        stroke="#b3a28a"
                        strokeWidth={2}
                        dot={false}
                        activeDot={{
                          stroke: "#b3a28a",
                          strokeWidth: 2,
                          fill: "#b3a28a",
                        }}
                      />
                    )}
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
            </div> */}


        {isLoading ? <LoaderSpinner /> : ""}
        <div className={styles.paddingDiv}></div>
      </div>
    </div>
  );
};

export default TesisatDetaylariDurumGrafikleri;
